import React from "react"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import parse from 'html-react-parser'
import { Arrow } from "../icons"

const ArticleCard = (props) => {

  if  (!props) {
    return null
  }

  return (
    <Link to={props.permalink} className="card card--article">
      <div className="card--article__image">
        {props.thumbnail && <Asset asset={props.thumbnail} />}
      </div>

      <div className="card--article__info">
        {props.categories?.length > 0 && <span>{props.categories[0].title}</span>}
        {props.title && <h3>{parse(props.title)}</h3>}
        {props.permalink && <span to={props.permalink}><Arrow/></span>}
      </div>
    </Link>
  )
}

export default ArticleCard
